const LISTE_PAIEMENT_FACTURE_ACHAT = {
  title: 'Liste des titres de recette à payer',
  titleForFactureAchat: 'Liste des factures achat à payer',
  breadcrumb: {
    racine: 'Accueil',
    listePaiementTitreRecette: 'Liste des titres de recette à payer',
    listePaiementFactureAchat: 'Liste des factures achat à payer',
  },
  actions: {
    replanifier: 'Replanifier',
    creationLotPaiement: 'Créer les paiements',
    filtre: 'Filtre',
    search: 'Rechercher',
    edit: 'Modifier',
    reload: 'Actualiser',
  },
  tabPaiementSurFacture: {
    factures: 'Factures',
    titreDeRecette: 'Titre de recette',
    facturesAchat: 'Factures achat',
    libelle: 'Libellé',
    codeDossier: 'Code dossier',
    dateEcheance: 'Date échéance',
    bailleur: 'Bailleur',
    collectivite: 'Collectivité',
    fournisseur: 'Fournisseur',
    montant: 'Montant',
    refPaiement: 'Référence paiement',
    bonAPayer: 'BAP',
    commentaire: 'Commentaire',
    validateur: 'Validateur(s)',
    blocageReglement: 'Bloc.',
    modeReglement: 'Mode règlement',
    motifBlocage: 'Motif',
    statusRapprochement: 'Rap.',
  },
  yes: 'Oui',
  no: 'Non',
  displayEchAnt: 'Afficher les factures antérieures non payées ({total})',
  masquerEchAnt: 'Masquer les factures antérieures non payées',
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    agence: 'Agence(s)',
    validateur: 'Validateur(s)',
    theme: 'Libellé',
    facture: 'Factures',
    montant: 'Montant',
    nomBailleur: 'Bailleur',
    nomFournisseur: 'Fournisseur',
    modeReglement: 'Mode de règlement',
    blocageReglement: 'Blocage paiement',
    codeDossierFacture: 'Code dossier',
    bonAPayer: 'Bon à payer',
    commentaire: 'Commentaire',
    refPaiement: 'Référence paiement',
    yes: 'Oui',
    no: 'Non',
    actions: {
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  messages: {
    successEdit: 'Vos factures ont été modifiées avec succès. Actualisez votre écran',
  },
};

export default LISTE_PAIEMENT_FACTURE_ACHAT;
